import { Link } from 'react-router-dom';
import { GLOBAL_COMPANY_INFO } from '../lib/cms';

export default function Footer() {
  return (
    <footer className="bg-slate-100 text-slate-700 pt-16 pb-12 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-slate-200">
          
          {/* Column 1: Business Profile */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src={GLOBAL_COMPANY_INFO.logo_url}
                alt="Maler Carsten Janum logo"
                className="h-14 sm:h-16 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Din lokale malermester i Aalborg og omegn. Over 20 års erfaring med kvalitetsmaling for både private og erhverv i Nord- og Midtjylland.
            </p>
            <div className="pt-2 text-xs text-slate-500 space-y-2">
              <div><span className="font-semibold text-slate-700">CVR-nr.:</span> {GLOBAL_COMPANY_INFO.cvr}</div>
              <a
                href="https://www.3byggetilbud.dk/leverandoer/maler-carsten-janum-aps/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-50 border border-amber-200 text-amber-900 rounded-lg font-medium hover:bg-amber-100 transition-colors"
              >
                <div className="flex text-amber-500 text-xs gap-0.5">
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                </div>
                <span>4,9 / 5 på 3Byggetilbud</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[9px] text-amber-700" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="space-y-4">
            <h3 className="text-[#1D352E] font-bold text-base tracking-wide border-l-2 border-[#65237e] pl-3">
              Hurtige genveje
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Ydelser
                </Link>
              </li>
              <li>
                <Link to="/projekter" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Projekter & Galleri
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Service Links */}
          <div className="space-y-4">
            <h3 className="text-[#1D352E] font-bold text-base tracking-wide border-l-2 border-[#65237e] pl-3">
              Vores Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/indendors-projekter" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Indendørs Projekter
                </Link>
              </li>
              <li>
                <Link to="/udendors-projekter" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Udendørsprojekter
                </Link>
              </li>
              <li>
                <Link to="/maler-norresundby" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Maler i Nørresundby
                </Link>
              </li>
              <li>
                <Link to="/maler-bronderslev" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Maler i Brønderslev
                </Link>
              </li>
              <li>
                <Link to="/maler-stovring" className="text-slate-600 hover:text-[#65237e] transition-colors inline-block font-medium">
                  Maler i Støvring
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Info & CTA */}
          <div className="space-y-4">
            <h3 className="text-[#1D352E] font-bold text-base tracking-wide border-l-2 border-[#65237e] pl-3">
              Kontakt information
            </h3>
            <address className="not-italic space-y-3 text-sm text-slate-600">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#65237e] mt-1 shrink-0" aria-hidden="true" />
                <span>{GLOBAL_COMPANY_INFO.address}</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#65237e] shrink-0" aria-hidden="true" />
                <a
                  href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`}
                  className="hover:text-[#65237e] transition-colors font-medium nowrap-contact"
                >
                  <span className="nowrap-contact">{GLOBAL_COMPANY_INFO.phone}</span>
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-[#65237e] shrink-0" aria-hidden="true" />
                <a
                  href={`mailto:${GLOBAL_COMPANY_INFO.email}`}
                  className="hover:text-[#65237e] transition-colors font-medium nowrap-contact"
                >
                  <span className="nowrap-contact">{GLOBAL_COMPANY_INFO.email}</span>
                </a>
              </div>
            </address>

            <div className="pt-2">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 text-xs font-semibold uppercase tracking-wider text-white bg-[#65237e] hover:bg-[#521b67] rounded-lg transition-colors text-center shadow-sm"
              >
                <span>Få uforpligtende tilbud</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-4">
          <p>© {new Date().getFullYear()} Maler Carsten Janum ApS. Alle rettigheder forbeholdes.</p>
          <p className="text-slate-500 font-medium">
            Kvalitetsmaler i Aalborg, Nørresundby, Brønderslev & Støvring
          </p>
        </div>
      </div>
    </footer>
  );
}
